import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const getWishlist = () => {
    return api.get(ENDPOINTS.WISHLIST.LIST);
};

export const addToWishlist = (data) => {
    return api.post(ENDPOINTS.WISHLIST.ADD, data);
};

export const removeFromWishlist = (variantId) => {
    return api.delete(ENDPOINTS.WISHLIST.REMOVE(variantId));
};

export const moveToCart = (variantId) => {
    return api.post(ENDPOINTS.WISHLIST.MOVE_TO_CART(variantId));
};
